import extractApiData from 'Helpers/extractApiData'
import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'Helpers/encodeParams'
import { evalCondition } from 'mailup-react-helpers'

const endpoints = (baseURL => {
  return {
    getAllLiquidProfileFilters: idList =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/liquidprofilefilters`,
    getFilter: id => `${baseURL}/api/filters/${encodeURIComponent(id)}`,
    getListOfFilters: idList =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/filters`,
    getListOfCategories: (
      pageSize,
      pageNumber,
      orderBy,
      orderDescending,
      name
    ) =>
      `${baseURL}/api/categories?${encodeParams({
        pageSize,
        pageNumber,
        orderBy,
        orderDescending,
        name
      })}`
  }
})(process.env.BEFILTERS_URL)

export const beFiltersGetFilter = id => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getFilter(id)
  }).then(extractApiData)
}

export const beFiltersGetAllLiquidProfileFilters = idList => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getAllLiquidProfileFilters(idList)
  }).then(extractApiData)
}

export const beFiltersGetListOfCategories = (
  pageSize,
  pageNumber,
  orderBy,
  orderDescending,
  name
) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getListOfCategories(
      pageSize,
      pageNumber,
      orderBy,
      orderDescending,
      name
    )
  }).then(extractApiData)
}
/**
 *
 * @param {number} idList ID of list
 * @param {Object} params
 * @param {number} params.pageSize The page size
 * @param {number} params.pageNumber The page number
 * @param {string} params.orderBy The column to order the result
 * @param {boolean} params.orderDescending Set true to order descending; otherwise ascending
 * @param {string} params.search Search filters by name
 * @param {Array(number)} params.categories Search filters by categories. [0] means searching filter without any category
 * @param {boolean} params.hidden Search filters by hidden status
 * @param {Array('Anagraphic'|'Activity'|'Device'|'Geolocation'|'Engagement'|'MultiType')} params.types Search filters by types
 *
 *
 */
export const beFiltersGetListOfFilters = (idList, params) => {
  if (!params.types?.length) {
    params.types = getAllAvailableFilterTypes()
  }
  const url = endpoints.getListOfFilters(idList)
  return apiWrapper({
    method: 'post',
    url: url,
    data: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(({ data }) => data)
}

//  getFilter
//
// /api/filters/{idfilter}
//  Get filter by id

/*
{
  "IdList": 0,
  "Name": "string",
  "Description": "string",
  "CustomDescription": true,
  "Hidden": true,
  "Category": 0,
  "UpdateDate": "2020-11-17T11:34:46.200Z",
  "Type": "Anagraphic",
  "Blocks": [
    {
      "JoinType": "Nil",
      "Conditions": [
        {
          "JoinType": "Nil",
          "SpecType": "GroupSpec"
        }
      ]
    }
  ],
  "Id": 0,
  "Locked": true
}

Type* ObjectTypestring
Enum:
[ Anagraphic, Activity, Device, Geolocation, MultiFilter, MultiType, Engagement ]

*/

export const FILTER_TYPE_DEVICE = 'Device'
export const FILTER_TYPE_ENGAGEMENT = 'Engagement'

export const getAllAvailableFilterTypes = () => {
  const hasEngagementFilters = evalCondition('co:DELSTATS OR co:ENGAGEMENT')
  return [
    'Anagraphic',
    'Activity',
    'Device',
    'Geolocation',
    'MultiType',
    hasEngagementFilters ? 'Engagement' : undefined
  ].filter(t => t !== undefined)
}
